/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Line item with embedded match metadata for efficient UI operations
 * @export
 * @interface LineItemWithMatchInfo
 */
export interface LineItemWithMatchInfo {
    /**
     * Database primary key for the line item
     * @type {number}
     * @memberof LineItemWithMatchInfo
     */
    lineItemId: number;
    /**
     * ID of the parent estimate
     * @type {number}
     * @memberof LineItemWithMatchInfo
     */
    estimateId: number;
    /**
     * ID of the associated room
     * @type {number}
     * @memberof LineItemWithMatchInfo
     */
    roomId: number | null;
    /**
     * Line item description
     * @type {string}
     * @memberof LineItemWithMatchInfo
     */
    description: string;
    /**
     * Line item number extracted from PDF (may be null)
     * @type {string}
     * @memberof LineItemWithMatchInfo
     */
    lineItemNumber?: string | null;
    /**
     * Quantity
     * @type {number}
     * @memberof LineItemWithMatchInfo
     */
    qty: number;
    /**
     * Unit of measure (e.g., "SQFT", "EA", "LF")
     * @type {string}
     * @memberof LineItemWithMatchInfo
     */
    uom: string;
    /**
     * Unit price in cents
     * @type {number}
     * @memberof LineItemWithMatchInfo
     */
    unitPriceCents: number;
    /**
     * Depreciation amount in cents
     * @type {number}
     * @memberof LineItemWithMatchInfo
     */
    depreciationCents?: number;
    /**
     * Whether the item is taxable
     * @type {boolean}
     * @memberof LineItemWithMatchInfo
     */
    taxable?: boolean;
    /**
     * Total line amount in cents
     * @type {number}
     * @memberof LineItemWithMatchInfo
     */
    rcvCents: number;
    /**
     * Tax amount in cents
     * @type {number}
     * @memberof LineItemWithMatchInfo
     */
    taxCents?: number | null;
    /**
     * Overhead and profit in cents
     * @type {number}
     * @memberof LineItemWithMatchInfo
     */
    opCents?: number | null;
    /**
     * When the line item was created
     * @type {Date}
     * @memberof LineItemWithMatchInfo
     */
    createdAt?: Date;
    /**
     * ID of the match group this line item belongs to (null if unmatched)
     * @type {number}
     * @memberof LineItemWithMatchInfo
     */
    lineItemMatchGroupId: number | null;
    /**
     * ID of the room match group this line item is associated with
     * @type {number}
     * @memberof LineItemWithMatchInfo
     */
    roomMatchGroupId: number | null;
    /**
     * Reason why this line item wasn't matched (if unmatched)
     * @type {string}
     * @memberof LineItemWithMatchInfo
     */
    unmatchedReason?: string | null;
}

/**
 * Check if a given object implements the LineItemWithMatchInfo interface.
 */
export function instanceOfLineItemWithMatchInfo(value: object): value is LineItemWithMatchInfo {
    if (!('lineItemId' in value) || value['lineItemId'] === undefined) return false;
    if (!('estimateId' in value) || value['estimateId'] === undefined) return false;
    if (!('roomId' in value) || value['roomId'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('qty' in value) || value['qty'] === undefined) return false;
    if (!('uom' in value) || value['uom'] === undefined) return false;
    if (!('unitPriceCents' in value) || value['unitPriceCents'] === undefined) return false;
    if (!('rcvCents' in value) || value['rcvCents'] === undefined) return false;
    if (!('lineItemMatchGroupId' in value) || value['lineItemMatchGroupId'] === undefined) return false;
    if (!('roomMatchGroupId' in value) || value['roomMatchGroupId'] === undefined) return false;
    return true;
}

export function LineItemWithMatchInfoFromJSON(json: any): LineItemWithMatchInfo {
    return LineItemWithMatchInfoFromJSONTyped(json, false);
}

export function LineItemWithMatchInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LineItemWithMatchInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'lineItemId': json['lineItemId'],
        'estimateId': json['estimateId'],
        'roomId': json['roomId'],
        'description': json['description'],
        'lineItemNumber': json['lineItemNumber'] == null ? undefined : json['lineItemNumber'],
        'qty': json['qty'],
        'uom': json['uom'],
        'unitPriceCents': json['unitPriceCents'],
        'depreciationCents': json['depreciationCents'] == null ? undefined : json['depreciationCents'],
        'taxable': json['taxable'] == null ? undefined : json['taxable'],
        'rcvCents': json['rcvCents'],
        'taxCents': json['taxCents'] == null ? undefined : json['taxCents'],
        'opCents': json['opCents'] == null ? undefined : json['opCents'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'lineItemMatchGroupId': json['lineItemMatchGroupId'],
        'roomMatchGroupId': json['roomMatchGroupId'],
        'unmatchedReason': json['unmatchedReason'] == null ? undefined : json['unmatchedReason'],
    };
}

export function LineItemWithMatchInfoToJSON(json: any): LineItemWithMatchInfo {
    return LineItemWithMatchInfoToJSONTyped(json, false);
}

export function LineItemWithMatchInfoToJSONTyped(value?: LineItemWithMatchInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lineItemId': value['lineItemId'],
        'estimateId': value['estimateId'],
        'roomId': value['roomId'],
        'description': value['description'],
        'lineItemNumber': value['lineItemNumber'],
        'qty': value['qty'],
        'uom': value['uom'],
        'unitPriceCents': value['unitPriceCents'],
        'depreciationCents': value['depreciationCents'],
        'taxable': value['taxable'],
        'rcvCents': value['rcvCents'],
        'taxCents': value['taxCents'],
        'opCents': value['opCents'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'lineItemMatchGroupId': value['lineItemMatchGroupId'],
        'roomMatchGroupId': value['roomMatchGroupId'],
        'unmatchedReason': value['unmatchedReason'],
    };
}

